module.exports = __webpack_public_path__ + "img/sample05.e0ca476d.gif";